var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import Link from 'cf-component-link';

var CardToolbarLink = function (_React$Component) {
  _inherits(CardToolbarLink, _React$Component);

  function CardToolbarLink(props) {
    _classCallCheck(this, CardToolbarLink);

    var _this = _possibleConstructorReturn(this, (CardToolbarLink.__proto__ || Object.getPrototypeOf(CardToolbarLink)).call(this, props));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass(CardToolbarLink, [{
    key: 'handleClick',
    value: function handleClick(e) {
      e.preventDefault();
      this.props.onClick();
    }
  }, {
    key: 'render',
    value: function render() {
      var className = 'cf-card__toolbar_link';

      if (this.props.isActive) {
        className += ' cf-card__toolbar_link--open';
      }

      return React.createElement(
        Link,
        {
          role: 'tab',
          id: this.props.id,
          className: className,
          onClick: this.handleClick
        },
        this.props.children
      );
    }
  }]);

  return CardToolbarLink;
}(React.Component);

CardToolbarLink.propTypes = {
  onClick: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired,
  id: PropTypes.string,
  children: PropTypes.node
};

export default CardToolbarLink;


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-card/es/CardToolbarLink.js
// module id = 616
// module chunks = 0